export interface QuotaUsage {
    current: number;
    limit: number;
}

// The API rejects a launch of more than 10 at once regardless of the account
// limit, so the offered maximum is the tighter of that ceiling and the account's
// remaining allowance.
export const LAUNCH_QUANTITY_CEILING = 10;

// Pass `undefined` while the quota is still unknown: the fallback of 1 errs low,
// which can never produce a launch the API will reject.
// ponytail: an account already at its limit still gets 1, so the form stays
// usable and the API's own message explains the refusal. Disable the deploy
// button here instead if that round trip ever becomes worth avoiding.
export function maxLaunchQuantity(quota?: QuotaUsage): number {
    if (!quota) return 1;
    return Math.max(1, Math.min(LAUNCH_QUANTITY_CEILING, quota.limit - quota.current));
}
